/*
 * @Descripttion:
 * @Author: 李子和
 * @Date: 2020-05-07 18:36:56
 */
/*
  @author: 张廷江
  @date: 10.12
*/
import router from './router'
import store from './store.js'
import cookie from './utils/cookie.js'
// import router from './router/index.js'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
// 加载进度条
NProgress.inc(0.2)
NProgress.configure({ easing: 'ease', speed: 500, showSpinner: false })
// 白名单
const whiteList = ['/', '/update-password']
router.beforeEach(async (to, from, next) => {
  NProgress.start()
  const token = cookie.getCookie('token')
  const role = cookie.getCookie('role')
  if (token && role) {
    if (to.path === '/' || to.path.indexOf('update-password') !== -1) {
      next()
    } else {
      // 登录过
      const hasRole = store.state.user.role
      if (hasRole) {
        next()
      } else {
        try {
          // const accessRouter = await store.dispatch('permission/getAsyncRoutes', role)
          // await store.dispatch('user/commitChangeRole', role)
          store.dispatch('permission/getAsyncRoutes', role).then(res => {
            const accessRouter = res
            store.dispatch('user/commitChangeRole', role).then(() => {
              router.addRoutes(accessRouter)
              next({ ...to, replace: true })
            })
          })

          // next()
        } catch (error) {
          console.log(error)
        }
      }
    }
  } else {
    // 未登录
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      // 重定向登录页
      // next(`/login?redirect=${to.path}`)
      next({ path: '/' })
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js